import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CountdownTimerModule, ExitDialogModule, PageViewModule, IfPopupButtonModule, IfStickyModule, IfScrollToModule } from 'ngx-if-lp-common';
import { AppComponent } from './app.component';
import { CcpaComponent } from './ccpa/ccpa.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';
import { BillingFormModule, BillingFormMobileInputModule, BillingFormInputModule, BillingFormSelectModule, BillingFormCountrySelectModule, BillingFormCheckboxModule, BillingFormStateSelectModule, BillingFormProductVariantSelectModule, AsyncImageModule, IfProductFaqModule, IfBillingFormMobileFlagInputModule, IfBillingFormCcExpiryInputModule, IfTranslationModule, IfQueryControlsModule, IfTestimonialsModule, IfVariantSelectModule, IfPurchaseNotificationsModule, IfSelectPaymentMethodModule, BillingFormRadioModule } from 'ngx-intellforce-billing';

@NgModule({
  declarations: [
    AppComponent,
    TermsComponent,
    PrivacyComponent,
    CcpaComponent,
    ImpressumComponent
  ],
  imports: [
    BrowserModule,
    BillingFormModule,
    BillingFormMobileInputModule,
    BillingFormInputModule,
    BillingFormSelectModule,
    BillingFormCountrySelectModule,
    BillingFormCheckboxModule,
    BillingFormStateSelectModule,
    BillingFormProductVariantSelectModule,
    CountdownTimerModule,
    AsyncImageModule,
    ExitDialogModule,
    PageViewModule,
    IfProductFaqModule,
    IfPurchaseNotificationsModule,
    IfPopupButtonModule,
    IfBillingFormMobileFlagInputModule,
    IfBillingFormCcExpiryInputModule,
    IfTranslationModule,
    IfQueryControlsModule,
    IfStickyModule,
    IfTestimonialsModule,
    IfScrollToModule,
    IfVariantSelectModule,
    IfSelectPaymentMethodModule,
    BillingFormRadioModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
